import { apiClient } from '@/api/client';
import { Business } from '@/api/models';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { DashboardLayout } from '@/components/layout/DashboardLayout';
import { useEntityDrawer } from '@/hooks/useEntityDrawer';
import { queryKeys } from '@/lib/queryKeys';
import { BusinessFormData } from '@/pages/businesses/hooks/useBusinessMutations';
import * as React from 'react';
import { BusinessDrawer } from './components/BusinessDrawer/index';
import { BusinessesList } from './components/BusinessesList';
import { useBusinessMutations } from './hooks/useBusinessMutations';

export const BusinessesPage: React.FC = () => {
  const { state, actions } = useEntityDrawer<Business>({
    basePath: '/businesses',
    queryKey: queryKeys.ADMIN_BUSINESS,
    fetchFn: async (id: number) => {
      const response = await apiClient.GET('/admin/businesses/{id}', {
        params: { path: { id } },
      });
      if (response.error) throw new Error('Failed to fetch business');
      return response.data as Business;
    },
    supportsCreate: false,
  });

  const {
    actions: mutationActions,
    isFormLoading,
    isDeleting,
    isTogglingReview,
    isDeletingImage,
    isSettingPrimaryImage,
  } = useBusinessMutations();

  const handleFormSubmit = async (formData: BusinessFormData) => {
    await mutationActions.handleFormSubmit(formData, state.entity);
  };

  return (
    <DashboardLayout>
      <ProtectedRoute action='read' subject='Business'>
        <BusinessesList
          onRowClick={business => actions.open(business.id!)}
          onEditBusiness={business => actions.edit(business.id!)}
          onDeleteBusiness={mutationActions.handleDeleteBusiness}
          isDeleting={isDeleting}
        />

        <BusinessDrawer
          onFormSubmit={handleFormSubmit}
          onDeleteBusiness={mutationActions.handleDeleteBusiness}
          onToggleReview={mutationActions.handleToggleReview}
          onDeleteImage={mutationActions.handleDeleteImage}
          onSetPrimaryImage={mutationActions.handleSetPrimaryImage}
          isFormLoading={isFormLoading}
          isTogglingReview={isTogglingReview}
          isDeletingImage={isDeletingImage}
          isSettingPrimaryImage={isSettingPrimaryImage}
        />
      </ProtectedRoute>
    </DashboardLayout>
  );
};
